import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  // ButtonGroup,
  Container,
  // Card,
  Col,
  Form,
  Row,
  // Modal,
  Spinner,
  // Dropdown,
  // Tooltip,
  // OverlayTrigger,
  // Nav,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
// import moment from "moment";
import { Formik } from "formik";
// import { Typeahead } from "react-bootstrap-typeahead";
import toastr from "toastr";

//Tabla, Navbar y Sidebar
// import CustomNavbar from "../../../components/CustomNavbar";
// import SibebarDescriptorsProfiles from "../../../components/descriptorsProfiles/SibebarDescriptorsProfiles";

//Redux
import {
  // getGeneralData,
  editGeneralData,
  getGeneralDataById,
  // saveGeneralData,
} from "../../../redux/descriptorsProfiles/GeneralData/actions";
import { getAreasJerarquia } from "../../../redux/areasfuncional/actions";
// import { saveAssignCompetencies } from "../../../redux/descriptorsProfiles/assignCompetencies/actions";

//Redux de menus desplegables
import { getDivision } from "../../../redux/division/actions";
import { getClassification } from "../../../redux/Classification/actions";
import { get_tasks, get_tasks_descriptors } from "../../../redux/tasks/actions";
import { getPurpose } from "../../../redux/descriptorsProfiles/Purpose/actions";
// import { getCompetenciesDesc } from "../../../redux/descriptorsProfiles/competenciesDesc/actions";
import { getOrgs } from "../../../redux/organization/actions";
// import Multiselect from "../../../components/Clima/Multiselect";
// import SearchOrganizationalUnit from "../../../components/descriptorsProfiles/SearchOrganizationalUnit";
import MultiselectFormik from "../../../components/MultiselectFormik";
import UnitList from "../../../components/descriptorsProfiles/UnitList";

const returnData = (value, cod) => {
  var _list = [];
  if (cod) {
    value.map((item) => {
      _list = [
        ..._list,
        { value: item.id, label: `${item.codigo} / ${item.descripcion}` },
      ];
    });
    return _list;
  } else {
    value.map((item) => {
      _list = [..._list, { value: item.id, label: item.descripcion }];
    });
    return _list;
  }
};

const returnData2 = (value) => {
  var _list = [];
  value.map((item) => {
    _list = [..._list, { value: item.id, label: item.nombre }];
  });
  return _list;
};

function GeneralData(props) {
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [unidSubmit, setUnidSubmit] = useState(false);
  // const [divisionSelected, setDivisionSelected] = useState([]);
  // const [competenciesDescSelected, setCompetenciesDescSelected] = useState([]);
  // const [classificationSelected, setClassificationnSelected] = useState([]);
  // const [tasksSelected, setTasksSelected] = useState([]);
  // const [personasSupervisaSelected, setPersonasSupervisaSelected] = useState(
  //   []
  // );
  // const [generoSelected, setGeneroSelected] = useState([]);
  // const [necesitaViajarSelected, setNecesitaViajarSelected] = useState([]);
  // const [purposeSelected, setPurposeSelected] = useState([]);
  // const [validUser, setValidUser] = useState();
  // const [_funcion, setFuncion] = useState([]);
  // const [validFunc, setValidFunc] = useState(true);
  // const [submitFunc, setSubmitFunc] = useState(false);
  const [unidadSeleccionada, setUnidadSeleccionado] = useState({});
  const [unidListSelected, setUnidListSelected] = useState([]);

  const dispatch = useDispatch();
  const userRoles = useSelector((store) => store.auth.userRoles);

  const schema = Yup.object().shape({
    nombre_posicion: Yup.string().required("**Campo requerido"),
    // descripcion_larga: Yup.string().required("***Campo requerido"),
    // division: Yup.string().required("***Campo requerido"),
    division: Yup.array().test({
      message: "**Campo requerido",
      test: (val) => val.length !== 0,
    }),
    //   competencia_descriptor: Yup.string().required("***Campo requerido"),
    clasificacion_empleado: Yup.string().required("***Campo requerido"),
    // empresa: Yup.string().required("***Campo requerido"),
    empresa: Yup.array().test({
      message: "**Campo requerido",
      test: (val) => val.length !== 0,
    }),
    // unidad_organizativa: Yup.string().required("***Campo requerido"),
    // posicion: Yup.string().required("***Campo requerido"),
    // proposito_general: Yup.string().required("***Campo requerido"),
    numero_personas_supervisa: Yup.string().required("***Campo requerido"),
    genero: Yup.string().required("***Campo requerido"),
    necesita_viajar: Yup.string().required("***Campo requerido"),
    numero_ocupantes: Yup.number()
      .integer("El número no puede tener decimales.")
      .min(0, "El valor minimo es 0.")
      .required("**Campo requerido"),
    vehiculo: Yup.string().required("***Campo requerido"),
    posiciones_sustitutas: Yup.array().required("***Campo requerido"),
    edad_minima: Yup.number().required("***Campo requerido"),
    edad_maxima: Yup.number().required("***Campo requerido"),
    posiciones: Yup.array().notRequired(),
  });

  const { unidOrg } = useSelector((store) => store.auth);

  const {
    loading,
    loadingById,
    saveLoading,
    generalData,
    genData,
    generalDataLength,
    generalDataError,
    formError,
    formErrorJson,
  } = useSelector((store) => store.generalData);

  //Listar valores de Divisiones
  const { divisionLength, division } = useSelector((store) => store.division);
  // const divisionLoading = useSelector((store) => store.division.loading);
  // let listDivision = [];
  // division.map((task) => {
  //   listDivision = [
  //     ...listDivision,
  //     {
  //       id: task.id,
  //       label: task.descripcion,
  //     },
  //   ];
  // });

  const areas = useSelector((store) => store.areas.areas);
  const loadingAreas = useSelector((store) => store.areas.loading);

  //Listar valores de Descriptor de competencias
  {
    /** 
  const { competenciesDesc } = useSelector((store) => store.competenciesDesc);
  let listCompetenciesDesc = [];

  if (competenciesDesc) {
    competenciesDesc.data.map((item) => {
      listCompetenciesDesc = [
        ...listCompetenciesDesc,
        {
          id: item.id,
          label: item.nombre,
        },
      ];
    });
  }

  */
  }

  //console.log("esto es competencias ", competenciesDesc.data);

  //Listar valores de Clasificación de empleado
  const { classification } = useSelector((store) => store.classification);
  const classificationLoading = useSelector(
    (store) => store.classification.loading
  );

  // let listClassification = [];
  // classification.map((item) => {
  //   listClassification = [
  //     ...listClassification,
  //     {
  //       id: item.id,
  //       label: item.nombre,
  //     },
  //   ];
  // });

  //Listar valores de posicion
  const { tasks } = useSelector((store) => store.tasks);
  const tasksLoading = useSelector((store) => store.tasks.loader);

  //Listar funciones que puede cubrir (posiciones sustitutas)
  // var listTasks = [];

  // tasks.map((item) => {
  //   listTasks = [
  //     ...listTasks,
  //     { value: item.id, label: `${item.codigo} / ${item.descripcion}` },
  //   ];
  // });

  // let listTasks = [];
  // tasks.map((item) => {
  //   listTasks = [
  //     ...listTasks,
  //     {
  //       id: item.id,
  //       label: item.nombre,
  //     },
  //   ];
  // });

  //Lista de opciones para No. de personas que supervisa
  const listPersonasSupervisa = [
    { id: 0, label: "0" },
    { id: 1, label: "1 - 10" },
    { id: 2, label: "11 - 20" },
    { id: 3, label: "21 - 30" },
    { id: 4, label: "31 o más" },
  ];

  //Lista de opciones para No. de personas que supervisa
  const listGenero = [
    { id: 0, label: "Femenino" },
    { id: 1, label: "Masculino" },
    { id: 2, label: "Indiferente" },
  ];

  //Lista de opciones para No. de personas que supervisa
  const listNecesitaViajar = [
    { id: 0, label: "Si" },
    { id: 1, label: "No" },
    { id: 2, label: "Ocasionalmente" },
  ];

  //Listar propositos
  const data = useSelector((store) => store.orgs.orgs);
  const loadingOrgs = useSelector((store) => store.orgs.loading);

  const evaluarValues = (valor) => {
    if (valor.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const onSubmit = async (req) => {
    setUnidSubmit(true);
    if (unidListSelected.length === 0) {
      toastr.info("Debe seleccionar almenos una unidad organizativa");
      return;
    }
    let _fun = [];
    let _div = [];
    let divTemp = req.division;
    let _emp = [];
    let empTemp = req.empresa;
    req.posiciones.length > 0 &&
      req.posiciones.map((item) => {
        _fun = [..._fun, item.value];
      });
    req.division.length > 0 &&
      req.division.map((item) => {
        _div = [..._div, item.value];
      });
    req.empresa.length > 0 &&
      req.empresa.map((item) => {
        _emp = [..._emp, item.value];
      });
    req.posiciones_sustitutas = _fun;
    req.division = _div;
    req.empresa = _emp;
    req.unidad_organizativa = [];
    unidListSelected.map((item) => {
      req.unidad_organizativa.push(item.id);
    });
    dispatch(editGeneralData(req, parseInt(props.match.params.id)));
    req.division = divTemp;
    req.empresa = empTemp;
  };

  const _getFuncionalAreas = (value = "") => {
    dispatch(getAreasJerarquia({ filter: value }, 2));
  };

  useEffect(() => {
    // setFuncion([]);
    dispatch(getGeneralDataById(parseInt(props.match.params.id)));
    setUnidSubmit(false);
  }, []);

  // useEffect(() => {
  //   // if (
  //   //   generalData &&
  //   //   generalData.posiciones_sustitutas &&
  //   //   generalData.posiciones_sustitutas.length > 0
  //   // ) {
  //   //   let tasksTemp = [];
  //   //   generalData.list_posiciones_sustitutas.map((item) => {
  //   //     const funcTemp = _funcion.find((fun) => fun.value === item.id);
  //   //     if (funcTemp === undefined) {
  //   //       tasksTemp = [...tasksTemp, { value: item.id }];
  //   //     }
  //   //   });
  //   //   setFuncion(tasksTemp);
  //   // }
  //   if (generalData && generalData.unidad_organizativa) {
  //     setUnidadSeleccionado(generalData.list_unidad_organizativa[0]);
  //   }
  // }, [generalData]);

  useEffect(() => {
    // dispatch(getGeneralDataById(parseInt(props.match.params.id)));
    dispatch(getDivision({}));
    dispatch(getClassification({}));
    dispatch(
      get_tasks_descriptors(
        {
          unidad_organizativa: unidOrg,
        },
        2
      )
    );
    dispatch(getPurpose({}));
    dispatch(getOrgs(parseInt(2)));
    // if (areas && areas.length === 0) {
    //   dispatch(getAreasJerarquia({}, 2));
    // }
  }, [dispatch, areas]);

  useEffect(() => {
    // if (
    //   generalData &&
    //   generalData &&
    //   generalData.list_division &&
    //   generalData.list_posicion &&
    //   // generalData.list_proposito_general &&
    //   generalData.numero_personas_supervisa &&
    //   generalData.necesita_viajar &&
    //   generalData.genero &&
    //   generalData.list_clasificacion_empleado
    // ) {
    //   setDivisionSelected([
    //     {
    //       id: generalData.list_division[0].id,
    //       label: generalData.list_division[0].descripcion,
    //     },
    //   ]);

    //   setClassificationnSelected([
    //     {
    //       id: generalData.list_clasificacion_empleado[0].id,
    //       label: generalData.list_clasificacion_empleado[0].nombre,
    //     },
    //   ]);

    //   setTasksSelected([
    //     {
    //       id: generalData.list_posicion[0].id,
    //       label: generalData.list_posicion[0].nombre,
    //     },
    //   ]);

    //   // setPurposeSelected([
    //   //   {
    //   //     id: generalData.list_proposito_general[0].id,
    //   //     label: generalData.list_proposito_general[0].nombre,
    //   //   },
    //   // ]);

    //   setGeneroSelected([
    //     {
    //       id: 0,
    //       label: generalData.genero,
    //     },
    //   ]);
    //   setNecesitaViajarSelected([
    //     {
    //       id: 0,
    //       label: generalData.necesita_viajar,
    //     },
    //   ]);
    //   setPersonasSupervisaSelected([
    //     {
    //       id: 0,
    //       label: generalData.numero_personas_supervisa,
    //     },
    //   ]);
    //   // setValidated(true);
    // } else {
    //   //  setCompetenciesDescSelected([]);
    //   setDivisionSelected([]);
    //   setClassificationnSelected([]);
    //   setTasksSelected([]);
    //   setPurposeSelected([]);
    //   setGeneroSelected([]);
    //   setNecesitaViajarSelected([]);
    //   setValidated(false);
    // }
    let unidTemp = [];
    if (generalData && generalData.list_unidad_organizativa) {
      generalData.list_unidad_organizativa.map((item) => {
        unidTemp.push(item);
      });
    }
    setUnidListSelected(unidTemp);
  }, [generalData, genData]);

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      {/* <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SibebarDescriptorsProfiles show={show} onShowSidebar={onShowSidebar} />
      <div className="my-5"> */}
      <Container fluid>
        {/* <div className="mb-4 px-2">
          <div className="d-flex justify-content-start align-items-center">
            <h4 className="font-weight-bold text-muted text-uppercase m-0">
              Oficial de capacitaciones / descriptor
            </h4>
          </div>
          <hr />
        </div> */}
        <Col className="my-4">
          <Col className="mx-3 d-flex flex-wrap justify-content-between align-items-center">
            <Row className="pl-md-4 pr-md-3 pl-2 pr-1 justify-content-end align-items-center flex-nowrap">
              <h6 className="font-weight-bold text-uppercase">
                Datos Generales
              </h6>
            </Row>
          </Col>
          <Col>
            <hr />
          </Col>
          {loadingById ? (
            <>
              <div className="d-flex justify-content-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center"
                />
              </div>
            </>
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={onSubmit}
              initialValues={{
                nombre_posicion:
                  generalData && generalData.nombre_posicion
                    ? generalData.nombre_posicion
                    : "",
                division:
                  generalData && generalData.list_division
                    ? returnData(generalData.list_division, false)
                    : [],
                clasificacion_empleado:
                  generalData && generalData.clasificacion_empleado
                    ? generalData.clasificacion_empleado
                    : "",
                numero_personas_supervisa:
                  generalData && generalData.numero_personas_supervisa
                    ? generalData.numero_personas_supervisa
                    : "",
                genero:
                  generalData && generalData.genero ? generalData.genero : "",
                necesita_viajar:
                  generalData && generalData.necesita_viajar
                    ? generalData.necesita_viajar
                    : "",
                vehiculo:
                  generalData && generalData.vehiculo
                    ? generalData.vehiculo
                    : "",
                empresa:
                  generalData && generalData.list_empresa
                    ? returnData(generalData.list_empresa, false)
                    : [],
                numero_ocupantes:
                  generalData && generalData.numero_ocupantes
                    ? generalData.numero_ocupantes
                    : 0,
                edad_minima:
                  generalData && generalData.edad_minima
                    ? generalData.edad_minima
                    : 0,
                edad_maxima:
                  generalData && generalData.edad_maxima
                    ? generalData.edad_maxima
                    : 0,
                // unidad_organizativa:
                //   generalData && generalData.unidad_organizativa
                //     ? generalData.unidad_organizativa
                //     : "",
                posiciones_sustitutas:
                  generalData && generalData.posiciones_sustitutas
                    ? generalData.posiciones_sustitutas
                    : [],
                posiciones: generalData.list_posiciones_sustitutas
                  ? returnData(generalData.list_posiciones_sustitutas, false)
                  : [],
              }}
            >
              {({
                handleSubmit,
                handleChange,
                setFieldValue,
                handleBlur,
                values,
                touched,
                errors,
              }) => (
                <Form onSubmit={handleSubmit} noValidate validated={validated}>
                  <Col>
                    {!!formError && (
                      <Alert variant="danger" className="my-2">
                        {formError}
                      </Alert>
                    )}
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label sm="12" md="12" className="my-2 col-3">
                        Nombre de la posición:
                      </Form.Label>
                      {/* <Col sm="12" md="8"> */}
                      <Col className="px-1">
                        <Form.Control
                          id="nombre_posicion"
                          name="nombre_posicion"
                          isInvalid={
                            touched.nombre_posicion && errors.nombre_posicion
                          }
                          isValid={
                            touched.nombre_posicion && !errors.nombre_posicion
                          }
                          onBlur={handleBlur("nombre_posicion")}
                          onChange={handleChange}
                          value={values.nombre_posicion}
                          className="rounded-pill"
                          type="text"
                          placeholder="Nombre Posición"
                          disabled={props.match.params.miDescriptor}
                        ></Form.Control>
                        {touched.nombre_posicion && errors.nombre_posicion && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.nombre_posicion}
                            </small>
                          </div>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label sm="12" md="12" className="my-2 col-3">
                        Empresa:
                      </Form.Label>
                      <Col className="px-1">
                        {!props.match.params.miDescriptor ? (
                          <>
                            <MultiselectFormik
                              id="empresa"
                              name="empresa"
                              options={returnData2(data)}
                              value={values.empresa}
                              onChange={(selected) => {
                                setFieldValue(
                                  "empresa",
                                  selected.length > 0 ? selected : []
                                );
                              }}
                              isValid={touched.empresa && !errors.empresa}
                              isInvalid={touched.empresa && errors.empresa}
                              isDisabled={
                                loadingOrgs || returnData2(data).length === 0
                              }
                              onBlur={() => handleBlur("empresa")}
                            />
                          </>
                        ) : (
                          <Form.Control
                            className="rounded"
                            as="textarea"
                            name="empresa"
                            style={{ resize: "none" }}
                            readOnly
                            defaultValue={
                              generalData && generalData.list_empresa
                                ? generalData.list_empresa.length > 0
                                  ? generalData.list_empresa.map((item) => {
                                      return (
                                        " " +
                                        item.codigo +
                                        " / " +
                                        item.nombre.toUpperCase()
                                      );
                                    })
                                  : "No tiene"
                                : "No tiene"
                            }
                            pattern="[A-Za-z0-9]+"
                          ></Form.Control>
                        )}
                        {/* <Form.Control
                          disabled={
                            loadingOrgs ||
                            (userRoles.length > 0 &&
                              !(
                                userRoles.includes("jefe") ||
                                userRoles.includes("administrador") ||
                                userRoles.includes(
                                  "Responsable_Descriptores_Perfiles"
                                )
                              ))
                          }
                          as="select"
                          name="empresa"
                          className="rounded-pill"
                          value={values.empresa}
                          onChange={handleChange}
                          isValid={touched.empresa && !errors.empresa}
                          isInvalid={touched.empresa && !!errors.empresa}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar Empresa
                          </option>
                          {data.length > 0 &&
                            data.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.nombre}
                              </option>
                            ))}
                        </Form.Control> */}
                        {touched.empresa && errors.empresa && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.empresa}
                            </small>
                          </div>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label sm="12" md="12" className="my-2 col-3">
                        Unidad organizativa:
                      </Form.Label>
                      <Col className="px-1">
                        <Row className="d-flex flex-wrap align-items-center">
                          <Col
                            sm={props.match.params.miDescriptor ? 12 : 11}
                            className="w-100"
                          >
                            {!props.match.params.miDescriptor ? (
                              <>
                                <Form.Control
                                  className="rounded"
                                  as="textarea"
                                  name="unidad_organizativa"
                                  style={{ resize: "none" }}
                                  readOnly
                                  value={
                                    unidListSelected.length > 0
                                      ? unidListSelected.map((item) => {
                                          return (
                                            " " +
                                            item.codigo +
                                            " / " +
                                            item.nombre.toUpperCase()
                                          );
                                        })
                                      : "No tiene"
                                  }
                                  pattern="[A-Za-z0-9]+"
                                ></Form.Control>
                                {/* <SearchOrganizationalUnit
                                  id="unidad_organizativa"
                                  name="unidad_organizativa"
                                  getFuncionalAreas={_getFuncionalAreas}
                                  handleBlur={handleBlur}
                                  areas={areas}
                                  unidadSeleccionada={unidadSeleccionada}
                                  setUnidadSeleccionado={setUnidadSeleccionado}
                                  setFieldValue={setFieldValue}
                                  isInvalid={
                                    touched.unidad_organizativa &&
                                    errors.unidad_organizativa
                                  }
                                  isValid={
                                    touched.unidad_organizativa &&
                                    !errors.unidad_organizativa
                                  }
                                  // unidad_organizativa={
                                  //   generalData.unidad_organizativa
                                  // }
                                  // list_unidad_organizativa={
                                  //   generalData.list_unidad_organizativa
                                  // }
                                  label={
                                    generalData.unidad_organizativa
                                      ? `${
                                          generalData
                                            .list_unidad_organizativa[0].codigo
                                            ? generalData
                                                .list_unidad_organizativa[0]
                                                .codigo
                                            : ""
                                        } / ${
                                          generalData
                                            .list_unidad_organizativa[0].nombre
                                        }`
                                      : ""
                                  }
                                />
                                {touched.unidad_organizativa &&
                                  errors.unidad_organizativa && (
                                    <div sm={1}>
                                      <small className="text-danger px-1">
                                        {errors.unidad_organizativa}
                                      </small>
                                    </div>
                                  )} */}
                                {unidSubmit &&
                                  unidListSelected.length === 0 && (
                                    <div sm={1}>
                                      <small className="text-danger px-1">
                                        **Debe seleccionar almenos una unidad
                                        organizativa
                                      </small>
                                    </div>
                                  )}
                              </>
                            ) : (
                              <Form.Control
                                className="rounded"
                                // type="text"
                                as="textarea"
                                name="unidad_organizativa"
                                style={{ resize: "none" }}
                                readOnly
                                defaultValue={
                                  generalData &&
                                  generalData.list_unidad_organizativa
                                    ? generalData.list_unidad_organizativa
                                        .length > 0
                                      ? generalData.list_unidad_organizativa.map(
                                          (item) => {
                                            return (
                                              " " +
                                              item.codigo +
                                              " / " +
                                              item.nombre.toUpperCase()
                                            );
                                          }
                                        )
                                      : "No tiene"
                                    : "No tiene"
                                }
                                pattern="[A-Za-z0-9]+"
                              ></Form.Control>
                            )}
                          </Col>
                          {/* {loadingAreas &&
                          userRoles.length > 0 &&
                          (userRoles.includes("jefe") ||
                            userRoles.includes("administrador") ||
                             userRoles.includes("alta_direccion") ||
                            userRoles.includes(
                              "Responsable_Descriptores_Perfiles"
                            )) ? (
                            <Col sm={1} className="mb-3">
                              <Spinner animation="border" size="sm" />
                            </Col>
                          ) : ( */}
                          {/* // <Col sm="2">// </Col> */}
                          {/* <> */}
                          {!props.match.params.miDescriptor ? (
                            <Col
                              sm={1}
                              className="d-flex flex-wrap align-items-center"
                            >
                              <Button
                                variant="light"
                                size="sm"
                                className="rounded-circle"
                                onClick={() => setShowModal(true)}
                              >
                                <i className="material-icons">
                                  app_registration
                                </i>
                              </Button>
                            </Col>
                          ) : null}
                          {/* </>
                          )} */}
                        </Row>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label sm="12" md="12" className="my-2 col-3">
                        Division:
                      </Form.Label>
                      <Col className="px-1">
                        {!props.match.params.miDescriptor ? (
                          <>
                            <MultiselectFormik
                              id="division"
                              name="division"
                              options={returnData(division, false)}
                              value={values.division}
                              onChange={(selected) => {
                                setFieldValue(
                                  "division",
                                  selected.length > 0 ? selected : []
                                );
                              }}
                              isValid={touched.division && !errors.division}
                              isInvalid={touched.division && errors.division}
                              isDisabled={
                                loadingOrgs ||
                                returnData(tasks, false).length === 0
                              }
                              onBlur={() => handleBlur("division")}
                            />
                          </>
                        ) : (
                          <Form.Control
                            className="rounded"
                            as="textarea"
                            name="division"
                            style={{ resize: "none" }}
                            readOnly
                            defaultValue={
                              generalData && generalData.list_division
                                ? generalData.list_division.length > 0
                                  ? generalData.list_division.map((item) => {
                                      return (
                                        " " +
                                        item.codigo +
                                        " / " +
                                        item.descripcion.toUpperCase()
                                      );
                                    })
                                  : "No tiene"
                                : "No tiene"
                            }
                            pattern="[A-Za-z0-9]+"
                          ></Form.Control>
                        )}
                        {/* <Typeahead
                          id="division"
                          name="division"
                          isInvalid={touched.division && errors.division}
                          isValid={touched.division && !errors.division}
                          onBlur={handleBlur("division")}
                          placeholder="Seleccione una opción"
                          options={listDivision}
                          onChange={(selected) => {
                            setFieldValue(
                              "division",
                              selected.length > 0 ? selected[0].id : ""
                            );
                            setDivisionSelected(selected);
                          }}
                          selected={divisionSelected}
                          disabled={
                            listDivision.length === 0 ||
                            (userRoles.length > 0 &&
                              !(
                                userRoles.includes("jefe") ||
                                userRoles.includes("administrador") ||
                                userRoles.includes(
                                  "Responsable_Descriptores_Perfiles"
                                )
                              ))
                          }
                          className="px-0"
                        ></Typeahead> */}
                        {touched.division && errors.division && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.division}
                            </small>
                          </div>
                        )}
                      </Col>
                    </Form.Group>
                    {/*Campo de clasificación de empleado */}
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label sm="12" md="12" className="my-2 col-3">
                        Clasificación empleado:
                      </Form.Label>
                      <Col className="px-1">
                        <Form.Control
                          as="select"
                          id="clasificacion_empleado"
                          name="clasificacion_empleado"
                          className="col rounded-pill"
                          value={values.clasificacion_empleado}
                          onChange={handleChange}
                          onBlur={handleBlur("clasificacion_empleado")}
                          isValid={
                            touched.clasificacion_empleado &&
                            !errors.clasificacion_empleado
                          }
                          isInvalid={
                            touched.clasificacion_empleado &&
                            !!errors.clasificacion_empleado
                          }
                          disabled={props.match.params.miDescriptor}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Seleccione una clasificación
                          </option>
                          {classification
                            .sort((a, b) =>
                              a.nombre > b.nombre
                                ? 1
                                : b.nombre > a.nombre
                                ? -1
                                : 0
                            )
                            .map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.nombre}
                              </option>
                            ))}
                        </Form.Control>
                        {/* <Typeahead
                          id="clasificacion_empleado"
                          name="clasificacion_empleado"
                          isInvalid={
                            touched.clasificacion_empleado &&
                            errors.clasificacion_empleado
                          }
                          isValid={
                            touched.clasificacion_empleado &&
                            !errors.clasificacion_empleado
                          }
                          onBlur={handleBlur("clasificacion_empleado")}
                          placeholder="Seleccione una opción"
                          options={listClassification}
                          onChange={(selected) => {
                            setFieldValue(
                              "clasificacion_empleado",
                              selected.length > 0 ? selected[0].id : ""
                            );
                            setClassificationnSelected(selected);
                          }}
                          selected={classificationSelected}
                          disabled={
                            listClassification.length === 0 ||
                            (userRoles.length > 0 &&
                              !(
                                userRoles.includes("jefe") ||
                                userRoles.includes("administrador") ||
                                 userRoles.includes("alta_direccion") ||
                                userRoles.includes(
                                  "Responsable_Descriptores_Perfiles"
                                )
                              ))
                          }
                          className="px-0"
                        ></Typeahead> */}
                        {touched.clasificacion_empleado &&
                          errors.clasificacion_empleado && (
                            <div>
                              <small className="text-danger px-2">
                                {errors.clasificacion_empleado}
                              </small>
                            </div>
                          )}
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label sm="12" md="12" className="my-2 col-3">
                        Género:
                      </Form.Label>
                      <Col className="px-1">
                        <Form.Control
                          disabled={props.match.params.miDescriptor}
                          as="select"
                          name="genero"
                          className="col rounded-pill"
                          value={values.genero}
                          onChange={handleChange}
                          isValid={touched.genero && !errors.genero}
                          isInvalid={touched.genero && !!errors.genero}
                          onBlur={handleBlur("genero")}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          ></option>
                          {listGenero.map((item) => (
                            <option key={item.id} value={item.label}>
                              {item.label}
                            </option>
                          ))}
                        </Form.Control>
                        {touched.genero && errors.genero && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.genero}
                            </small>
                          </div>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label sm="12" md="12" className="my-2 col-3">
                        Necesita viajar:
                      </Form.Label>
                      <Col className="px-1">
                        <Form.Control
                          disabled={props.match.params.miDescriptor}
                          as="select"
                          name="necesita_viajar"
                          className="rounded-pill"
                          value={values.necesita_viajar}
                          onChange={handleChange}
                          isValid={
                            touched.necesita_viajar && !errors.necesita_viajar
                          }
                          isInvalid={
                            touched.necesita_viajar && !!errors.necesita_viajar
                          }
                          onBlur={handleBlur("necesita_viajar")}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          ></option>
                          {listNecesitaViajar.map((item) => (
                            <option key={item.id} value={item.label}>
                              {item.label}
                            </option>
                          ))}
                        </Form.Control>
                        {touched.necesita_viajar && errors.necesita_viajar && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.necesita_viajar}
                            </small>
                          </div>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label sm="12" md="12" className="my-2 col-3">
                        Vehiculo:
                      </Form.Label>
                      <Col className="px-1">
                        <Form.Control
                          disabled={props.match.params.miDescriptor}
                          as="select"
                          name="vehiculo"
                          className="rounded-pill"
                          value={values.vehiculo}
                          onChange={handleChange}
                          isValid={touched.vehiculo && !errors.vehiculo}
                          isInvalid={touched.vehiculo && !!errors.vehiculo}
                          onBlur={handleBlur("vehiculo")}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          ></option>
                          {listNecesitaViajar.map((item) => (
                            <option key={item.id} value={item.label}>
                              {item.label}
                            </option>
                          ))}
                        </Form.Control>
                        {touched.vehiculo && errors.vehiculo && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.vehiculo}
                            </small>
                          </div>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label sm="12" md="12" className="my-2 col-3">
                        Posiciones que puede cubrir:
                      </Form.Label>
                      <Col className="px-1">
                        <Col sm={tasksLoading ? "10" : "12"} className="px-0">
                          {!props.match.params.miDescriptor ? (
                            // <Multiselect
                            //   options={listTasks}
                            //   value={_funcion}
                            //   onChange={setFuncion}
                            //   isValid={validFunc}
                            //   isDisabled={false}
                            //   isSubmit={submitFunc}
                            // />
                            <MultiselectFormik
                              id="posiciones"
                              name="posiciones"
                              options={returnData(tasks, false)}
                              value={values.posiciones}
                              onChange={(selected) => {
                                setFieldValue(
                                  "posiciones",
                                  selected.length > 0 ? selected : []
                                );
                              }}
                              isValid={touched.posiciones && !errors.posiciones}
                              isInvalid={
                                touched.posiciones && errors.posiciones
                              }
                              isDisabled={
                                loadingOrgs ||
                                returnData(tasks, false).length === 0
                              }
                              onBlur={() => handleBlur("posiciones")}
                            />
                          ) : (
                            <Form.Control
                              as="textarea"
                              name="posicion_sustitutas"
                              style={{ resize: "none" }}
                              readOnly
                              defaultValue={
                                generalData && generalData.posiciones_sustitutas
                                  ? generalData.posiciones_sustitutas.length > 0
                                    ? generalData.list_posiciones_sustitutas.map(
                                        (item) => {
                                          return (
                                            " " +
                                            item.codigo +
                                            " / " +
                                            item.descripcion
                                          );
                                        }
                                      )
                                    : "No tiene"
                                  : null
                              }
                              pattern="[A-Za-z0-9]+"
                            ></Form.Control>
                          )}
                        </Col>
                      </Col>
                      {tasksLoading && props.match.params.miDescriptor && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label sm="12" md="12" className="my-2 col-3">
                        No. ocupantes:
                      </Form.Label>
                      <Col className="px-1">
                        <Form.Control
                          id="numero_ocupantes"
                          name="numero_ocupantes"
                          disabled={props.match.params.miDescriptor}
                          isInvalid={
                            touched.numero_ocupantes && errors.numero_ocupantes
                          }
                          isValid={
                            touched.numero_ocupantes && !errors.numero_ocupantes
                          }
                          onBlur={handleBlur("numero_ocupantes")}
                          onChange={handleChange}
                          value={values.numero_ocupantes}
                          className="rounded-pill"
                          type="number"
                          placeholder="0"
                          min={0}
                        ></Form.Control>
                        {touched.numero_ocupantes &&
                          errors.numero_ocupantes && (
                            <Col>
                              <small className="text-danger px-2">
                                {errors.numero_ocupantes}
                              </small>
                            </Col>
                          )}
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label sm="12" md="12" className="my-2 col-3">
                        No. Personas que supervisa:
                      </Form.Label>
                      <Col className="px-1">
                        <Form.Control
                          disabled={props.match.params.miDescriptor}
                          as="select"
                          name="numero_personas_supervisa"
                          className="rounded-pill"
                          value={values.numero_personas_supervisa}
                          onChange={handleChange}
                          isValid={
                            touched.numero_personas_supervisa &&
                            !errors.numero_personas_supervisa
                          }
                          isInvalid={
                            touched.numero_personas_supervisa &&
                            !!errors.numero_personas_supervisa
                          }
                          onBlur={handleBlur("numero_personas_supervisa")}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Seleccione una opción
                          </option>
                          {listPersonasSupervisa.map((item) => (
                            <option key={item.id} value={item.label}>
                              {item.label}
                            </option>
                          ))}
                        </Form.Control>
                        {/* <Typeahead
                          id="numero_personas_supervisa"
                          name="numero_personas_supervisa"
                          isInvalid={
                            touched.numero_personas_supervisa &&
                            errors.numero_personas_supervisa
                          }
                          isValid={
                            touched.numero_personas_supervisa &&
                            !errors.numero_personas_supervisa
                          }
                          onBlur={handleBlur("numero_personas_supervisa")}
                          placeholder="Seleccione una opción"
                          options={listPersonasSupervisa}
                          onChange={(selected) => {
                            setFieldValue(
                              "numero_personas_supervisa",
                              selected.length > 0 ? selected[0].label : ""
                            );

                            setPersonasSupervisaSelected(selected);
                          }}
                          selected={personasSupervisaSelected}
                          disabled={
                            userRoles.length > 0 &&
                            !(
                              userRoles.includes("jefe") ||
                              userRoles.includes("administrador") ||
                               userRoles.includes("alta_direccion") ||
                              userRoles.includes(
                                "Responsable_Descriptores_Perfiles"
                              )
                            )
                          }
                          className="px-0"
                        ></Typeahead> */}
                        {touched.numero_personas_supervisa &&
                          errors.numero_personas_supervisa && (
                            <Col>
                              <small className="text-danger px-2">
                                {errors.numero_personas_supervisa}
                              </small>
                            </Col>
                          )}
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label sm="12" md="12" className="my-2 col-3">
                        Edad mínima:
                      </Form.Label>
                      <Col className="px-1">
                        <Form.Control
                          id="edad_minima"
                          name="edad_minima"
                          isInvalid={touched.edad_minima && errors.edad_minima}
                          isValid={touched.edad_minima && !errors.edad_minima}
                          onBlur={handleBlur("edad_minima")}
                          onChange={handleChange}
                          value={values.edad_minima}
                          className="rounded-pill"
                          type="number"
                          placeholder="Edad mínima"
                          disabled={props.match.params.miDescriptor}
                        ></Form.Control>
                        {touched.edad_minima && errors.edad_minima && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.edad_minima}
                            </small>
                          </div>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label sm="12" md="12" className="my-2 col-3">
                        Edad máxima:
                      </Form.Label>
                      <Col className="px-1">
                        <Form.Control
                          id="edad_maxima"
                          name="edad_maxima"
                          isInvalid={touched.edad_maxima && errors.edad_maxima}
                          isValid={touched.edad_maxima && !errors.edad_maxima}
                          onBlur={handleBlur("edad_maxima")}
                          onChange={handleChange}
                          value={values.edad_maxima}
                          className="rounded-pill"
                          type="number"
                          placeholder="Edad máxima"
                          disabled={props.match.params.miDescriptor}
                        ></Form.Control>
                        {touched.edad_maxima && errors.edad_maxima && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.edad_maxima}
                            </small>
                          </div>
                        )}
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Col className="d-flex flex-wrap justify-content-end align-items-center">
                      {props.match.params.miDescriptor ? null : (
                        <Button
                          className="rounded-pill"
                          disabled={loading}
                          variant="primary"
                          type="submit"
                        >
                          {loading && (
                            <Spinner
                              className="mr-2"
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          )}
                          Guardar
                        </Button>
                      )}
                    </Col>
                  </Col>
                </Form>
              )}
            </Formik>
          )}
        </Col>
      </Container>
      {loadingById ? (
        <>
          <div className="d-flex justify-content-center">
            <Spinner
              animation="border"
              role="status"
              className="d-flex justify-content-center"
            />
          </div>
        </>
      ) : (
        <UnitList
          item={generalData}
          show={showModal}
          handleClose={() => setShowModal(false)}
          unidListSelected={unidListSelected}
          setUnidListSelected={setUnidListSelected}
        />
      )}
      {/* </div> */}
    </>
  );
}

export default GeneralData;
